<script setup>
import { computed, ref } from 'vue'
import { useNotification } from "@kyvg/vue3-notification"
import { useStore } from 'vuex'
import FormButton from '@/components/Atoms/FormButton.vue'
import FormInput from '@/components/Atoms/FormInput.vue'
import ButtonCopyToClipboard from '@/components/Moleculas/ButtonCopyToClipboard.vue'
import IconBase from '@/components/icon/IconBase.vue'
import IconLinkExternal from '@/components/icon/IconLinkExternal.vue'
import FormSwitch from '@/components/Atoms/FormSwitch.vue'
import EmbedCodeWidget from '@/components/Moleculas/EmbedCodeWidget.vue'
import { track, EVENTS } from '@/lib/tracking'

const { notify } = useNotification()
const store = useStore()

const player = computed(() => store.getters['DynamicPlayers/dynamicPlayer'])

const embedResponsive = ref(true)

const dynamicPlayerUrl = computed(() => {
  if (!player.value?.key) return ''
  return `${process.env.VUE_APP_PLAYER_APP_BASE_URL}/${player.value.key}`
})


const clipboardCopy = async (text) => {
  if (!text) return
  await navigator.clipboard.writeText(text)
  notify({ group: 'info', text: 'Copied to clipboard' })
}

const trackDynamicUrlCopied = () => {
  track(EVENTS.CONTENT_URL_COPIED, { contentType: 'dynamic' })
}
// EmbedCodeWidget wraps the copy button (ButtonCopyToClipboard -> VDropdown, class
// `v-popper`). Only fire when the copy control was clicked, not the Responsive toggle.
const onDynamicEmbedAreaClick = (e) => {
  if (e.target?.closest?.('.v-popper')) {
    track(EVENTS.EMBED_CODE_COPIED, { contentType: 'dynamic', copyType: embedResponsive.value ? 'responsive' : 'fixed' })
  }
}
</script>

<template>
  <section class="bg-surface-2 rounded-xl shadow-[0_2px_6px_rgba(0,0,0,0.28)] p-4 md:p-5">
    <div @click="onDynamicEmbedAreaClick">
      <EmbedCodeWidget :url="dynamicPlayerUrl" :disabled="!dynamicPlayerUrl" v-model="embedResponsive" />
    </div>
    <div class="flex items-center relative gap-x-2">
      <FormInput
        label="Direct Player Link"
        :modelValue="dynamicPlayerUrl"
        customClasses="!pr-16"
        :disabled="!dynamicPlayerUrl"
        @click="clipboardCopy(dynamicPlayerUrl); trackDynamicUrlCopied()"
        readonly
      />
      <ButtonCopyToClipboard class="absolute right-6 bottom-0.5 z-10" isIcon :disabled="!dynamicPlayerUrl" :text="dynamicPlayerUrl" @click="trackDynamicUrlCopied" />
      <FormButton class="absolute right-0 bottom-0.5 z-10" :href="dynamicPlayerUrl" :disabled="!dynamicPlayerUrl" isIcon target="_blank" type="link">
        <icon-base class="shrink-0" fill="transparent">
          <IconLinkExternal />
        </icon-base>
      </FormButton>
    </div>
  </section>
</template>
